import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import {Location} from '@angular/common';

import { BasicValidators } from '../shared/basic-validators';
import {Funcoes} from "../funcoes";
import {Global} from "../global";
import {MercadoriasService} from "../mercadorias/mercadorias.service";
import {MercadoriasCategoriasModel} from "./mercadorias-categorias.model";
import {MercadoriasCategoriasService} from "./mercadorias-categorias.service";


@Component({
  selector: 'app-mercadorias-categorias-form',
  templateUrl: './mercadorias-categorias-form.component.html'
})
export class MercadoriasCategoriasFormComponent implements OnInit {

  form: FormGroup;
  title: string;
  categoria: MercadoriasCategoriasModel = new MercadoriasCategoriasModel();
  pageIsUpd: boolean = false;
  pageIsAdd: boolean = false;
  enviando = false;
  listMercadorias = [];

  constructor(
    formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private mercadoriasCategoriasService: MercadoriasCategoriasService,
    private mercadoriasService: MercadoriasService,
    private _location: Location,
    public func: Funcoes,
    public global: Global
  ) {
    this.form = formBuilder.group({
      id_categoria: [],
      nome: ['', [
        Validators.required,
        Validators.minLength(3),
        Validators.maxLength(45)
      ]]
    });
  }

  ngOnInit() {

    // verifica se é uma página de edição
    if(this.router.url.split(/\//).pop() == 'upd'){
      this.pageIsUpd = true;
    }

    // verifica se é uma página para adicionar
    if(this.router.url.split(/\//).pop() == 'add'){
      this.pageIsAdd = true;
    }

    this.mercadoriasService.get()
      .subscribe(
        json => {
          this.listMercadorias = json.Payload;

          if(this.global.debug == true){
            console.log(json.Payload);
          }
        },
        error => {
          this.func.showErro(error.json());
        });

    this.route.params.subscribe(params => {
      let id = params['id_categoria'];

      if(!this.pageIsUpd){
        this.title = this.func.traduzir('front.editarCategoria');
      }else{
        this.title = id ? this.func.traduzir('front.visualizarCategoria') : this.func.traduzir('front.cadastrarNovaCategoria');
      }

      if (!id) {
        return;
      }

      this.mercadoriasCategoriasService.getById(id)
        .subscribe(
          json => {
            if(this.pageIsUpd) {
              this.title = this.func.traduzir('front.editarCategoria')+': '+json.Payload[0].nome;
            }else{
              this.title = this.func.traduzir('front.visualizarCategoria') + ': ' + json.Payload[0].nome;
            }
            this.categoria = json.Payload[0];

            if(this.global.debug == true){
              console.log(json.Payload[0]);
            }
          },
          error => {
            this.func.showErro(error.json());
          });
    });
  }

  voltar() {
    this._location.back();
  }

  save() {
    this.enviando = true;
    let result,

    values = this.form.value;

    if (values.id_categoria) {
      result = this.mercadoriasCategoriasService.editar(values, values.id_categoria);
    } else {
      result = this.mercadoriasCategoriasService.adicionar(values);
    }

    result.subscribe(data => this.router.navigate(['/painel', 'mercadorias', 'categorias']),
      error => {
        this.enviando = false;
        this.func.showErro(error.json());
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/mercadorias-categorias/mercadorias-categorias-form.component.ts